/**
 * TimeSyncService.
 * Provides precise time synced with server across whole platform. Accessible from any class. Behaves as singleton
 *
 * @copyright Realeyes OU. All rights reserved.
 */

import Stopwatch from '../../utils/Stopwatch';
import getCurrentTime from '../../utils/getCurrentTime';
import Logger from '../Logger';

export default class TimeSyncService {
    /**
     * Creates TimeSyncService instance.
     * @param{ConfigurationManager} configurationManager entity to get configuration
     */
    constructor(configurationManager) {
        this.logger = new Logger('TSS', configurationManager.isDebugMode());
        this.stopwatch = new Stopwatch();
        this.globalSW = new Stopwatch();
        this.globalSW.start();
        this.sync();
    }

    /**
     * Sync server time
     * @return{Promise.<boolean>}
     */
    sync() {
        this.logger.logDebug(`started to sync time: ${JSON.stringify(getCurrentTime())}`);
        // todo: get the time from server
        this.serverTime = Date.now();
        this.stopwatch.start();
        this.logger.logDebug(`time is synced: ${JSON.stringify(getCurrentTime())}`);
        return Promise.resolve(true);
    }

    /**
     * Provides current time from server and client
     *
     * @return {Object.<{
     *  serverTimestamp: int,
     *  clientTimestamp: int,
     *  clientTimeStamp: int,
     *  serviceStarted: int,
     *  }>}
     */
    getCurrentTimeInfo() {
        const timeInfo = {};
        timeInfo.serverTimestamp = this.serverTime + this.stopwatch.elapsed();
        timeInfo.clientPreciseTime = getCurrentTime();
        timeInfo.clientTimestamp = Date.now();
        timeInfo.serviceStarted = this.globalSW.elapsed();
        return timeInfo;
    }
}
